import { useTimezoneParam } from '@features/date-time';
import { useFilter } from '@features/table-filter';

import { useGetTradersQuery } from '../api';
import type { ITraderFilter } from '../model/types';

interface IProps {
  disableUrlFilter?: boolean;
  refreshInterval?: string;
}

export const useTraders = ({ disableUrlFilter, refreshInterval }: IProps = {}) => {
  const filter = useFilter<ITraderFilter>({ disableUrlFilter });
  const { currentFilter, updateFilter } = filter;

  useTimezoneParam({ currentFilter, updateFilter });

  const {
    data: traders,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetTradersQuery(currentFilter.toString(), {
    pollingInterval:
      !refreshInterval || refreshInterval === 'off' ? undefined : parseInt(refreshInterval),
  });

  return {
    traders,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
